import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  GET_ACQUISITION_CHANNEL_LIST,
  GET_ACQUISITION_CHANNEL_DATA,
  CREATE_ACQUISITION_CHANNEL,
  UPDATE_ACQUISITION_CHANNEL,
  DELETE_ACQUISITION_CHANNEL,
} from "./actionType";

import {
  getAcquisitionChannelListSuccess,
  getAcquisitionChannelListFailure,
  getAcquisitionChannelDataSuccess,
  getAcquisitionChannelDataFailure,
  createAcquisitionChannelSuccess,
  createAcquisitionChannelFailure,
  updateAcquisitionChannelSuccess,
  updateAcquisitionChannelFailure,
  deleteAcquisitionChannelSuccess,
  deleteAcquisitionChannelFailure,
} from "./action";

import {
  getAcquisitionChannelListApi,
  getAcquisitionChannelDataApi,
  createAcquisitionChannelApi,
  updateAcquisitionChannelApi,
  deleteAcquisitionChannelApi,
} from "../../helpers/fakebackend_helper";

// Get Acquisition Channel List
function* getAcquisitionChannelListSaga() {
  try {
    const response = yield call(getAcquisitionChannelListApi);
    yield put(getAcquisitionChannelListSuccess(response));
  } catch (error) {
    yield put(getAcquisitionChannelListFailure());
  }
}

export function* watchGetAcquisitionChannelListSaga() {
  yield takeLatest(GET_ACQUISITION_CHANNEL_LIST, getAcquisitionChannelListSaga);
}

// Get Acquisition Channel data
function* getAcquisitionChannelDataSaga({ payload }) {
  try {
    const response = yield call(getAcquisitionChannelDataApi, payload);
    yield put(getAcquisitionChannelDataSuccess(response));
  } catch (error) {
    yield put(getAcquisitionChannelDataFailure());
  }
}

export function* watchGetAcquisitionChannelDataSaga() {
  yield takeLatest(GET_ACQUISITION_CHANNEL_DATA, getAcquisitionChannelDataSaga);
}

// Create Acquisition Channel
function* createAcquisitionChannelSaga({ payload }) {
  try {
    const response = yield call(createAcquisitionChannelApi, payload);
    yield put(createAcquisitionChannelSuccess(response));
  } catch (error) {
    yield put(createAcquisitionChannelFailure());
  }
}

export function* watchCreateAcquisitionChannelSaga() {
  yield takeLatest(CREATE_ACQUISITION_CHANNEL, createAcquisitionChannelSaga);
}

// Update Acquisition Channel
function* updateAcquisitionChannelSaga({ payload }) {
  try {
    const response = yield call(updateAcquisitionChannelApi, payload);
    yield put(updateAcquisitionChannelSuccess(response));
  } catch (error) {
    yield put(updateAcquisitionChannelFailure());
  }
}

export function* watchUpdateAcquisitionChannelSaga() {
  yield takeLatest(UPDATE_ACQUISITION_CHANNEL, updateAcquisitionChannelSaga);
}

// Delete Acquisition Channel
function* deleteAcquisitionChannelSaga({ payload }) {
  try {
    const response = yield call(deleteAcquisitionChannelApi, payload);
    yield put(deleteAcquisitionChannelSuccess(response));
  } catch (error) {
    yield put(deleteAcquisitionChannelFailure());
  }
}

export function* watchDeleteAcquisitionChannelSaga() {
  yield takeLatest(DELETE_ACQUISITION_CHANNEL, deleteAcquisitionChannelSaga);
}

export default function* CustomerAcquisitionChannel() {
  yield all([
    watchGetAcquisitionChannelListSaga(),
    watchGetAcquisitionChannelDataSaga(),
    watchCreateAcquisitionChannelSaga(),
    watchUpdateAcquisitionChannelSaga(),
    watchDeleteAcquisitionChannelSaga(),
  ]);
}
